import apiAuthClient from '@/services/apiAuthClient';

import errorHandler from '@/utilities/serverErrorHandler';

export const notes = {
  namespaced: true,
  state: {
    notes: {
      ua_icexpressionofinterest: [],
      ua_icapplication: [],
      ua_icclaim: []
    }

  },
  getters: {
    getAllNotes: state => (applicationType) => {
      return state.notes[applicationType];
    },
    getNotesByType: state => (applicationType, itemType) => {
      const notes = state.notes[applicationType].filter(item => item.subject === itemType);
      return notes;
    }
  },
  mutations: {
    UPDATE (state, payload) {
      const notes = state.notes[payload.applicationType];
      state.notes[payload.applicationType] = [...notes, ...payload.notes];
    },
    CREATE (state, payload) {
      state.notes[payload.applicationType] = payload.notes;
    }
  },
  actions: {
    uploadToSharepoint ({ commit, dispatch, rootGetters }, payload) {
      dispatch('ui/updateInterstitial', { isLoading: true, message: 'Uploading your supporting files...' }, { root: true });
      return apiAuthClient.post('SaveNewDocumentToSharepoint', JSON.stringify(payload), rootGetters['auth/getAccessToken']).then((res) => {
        if (res.status === 200 && res.data) {
          commit('UPDATE', { applicationType: 'ua_icclaim', files: [payload] });

          return true;
         }
      }).catch(err => {
        return errorHandler('notesErrors', err);
      }).finally(() => {
        dispatch('ui/updateInterstitial', { isLoading: false, message: '' }, { root: true });
      });
    },
    uploadNotes ({ commit, dispatch, rootGetters }, payload) {
      dispatch('ui/updateInterstitial', { isLoading: true, message: 'Uploading your supporting files...' }, { root: true });

      return apiAuthClient.post(`addicnotes?contractid=${process.env.VUE_APP_CONTRACT_ID}`, JSON.stringify(payload.data), rootGetters['auth/getAccessToken']).then((res) => {
        if (res.status === 200 && res.data) {
          const successes = res.data.filter(item => item.IsUploaded === true);
         const failures = res.data.filter(item => item.IsUploaded === false);
         const failedFiles = [];

         failures.forEach((item) => {
          failedFiles.push(item.FileName);
         });

         const err = { type: 'error', message: `The following files have failed to upload: ${failedFiles.join(',')}. Please check the guidance and try again` };
         if (failures.length) {
          return err;
         } else {
          const items = [];
          successes.forEach((item) => {
            const itemPayload = {
              filename: item.FileName,
              subject: payload.itemType
            };
            items.push(itemPayload);
          });
          commit('UPDATE', { applicationType: payload.applicationType, notes: items });
          return true;
         }
        }
      }).catch(err => {
        if (err.response) {
          return errorHandler('notesErrors', err);
        }
      return { message: 'The files you are trying to upload exceed the maximum file size of 10MB. Please try reducing the file size before uploading', type: 'error' };
      }).finally(() => {
        dispatch('ui/updateInterstitial', { isLoading: false, message: '' }, { root: true });
      });
    },
    loadNotes ({ commit, dispatch, rootGetters }, payload) {
      dispatch('ui/updateInterstitial', { isLoading: true, message: 'Getting your uploaded files...' }, { root: true });

      return apiAuthClient.get(`geticnotes/${process.env.VUE_APP_CONTRACT_ID}?entityname=${payload.applicationTypeId}${payload.claimIdQuery}`, rootGetters['auth/getAccessToken']).then((res) => {
        if (res.status === 200 && res.data) {
          const items = [];
          res.data.forEach((item) => {
            items.push(item);
          });
          commit('CREATE', { applicationType: payload.applicationTypeId, notes: items });
          return true;
        }
      }).catch(err => {
          return errorHandler('notesErrors', err);
      }).finally(() => {
        dispatch('ui/updateInterstitial', { isLoading: false, message: '' }, { root: true });
      });
    }
  }

};
